import Box from '@mui/material/Box';
import type { SvgIconProps } from '@mui/material/SvgIcon';
import type { SxProps, Theme } from '@mui/material/styles';
import type { ComponentType, ReactNode } from 'react';

const DEFAULT_SIZE = 30;
const DEFAULT_ICON_SIZE = 18;

interface IconBadgeProps {
  icon: ComponentType<SvgIconProps>;
  size?: number;
  iconSize?: number;
  sx?: SxProps<Theme>;
}

export function IconBadge({
  icon: Icon,
  size = DEFAULT_SIZE,
  iconSize = DEFAULT_ICON_SIZE,
  sx,
}: IconBadgeProps): ReactNode {
  return (
    <Box
      sx={[
        {
          width: size,
          height: size,
          flexShrink: 0,
          borderRadius: 1.2,
          display: 'grid',
          placeItems: 'center',
          bgcolor: 'primary.bg',
          color: 'primary.main',
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      <Icon sx={{ fontSize: iconSize }} />
    </Box>
  );
}
